<span
  #contextMenu="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  [style.top]="position[1] + 'px'"
  [style.left]="position[0] + 'px'"
  class="context-menu-container"
  [matMenuTriggerRestoreFocus]="false"
  (menuClosed)="refocusOutput()"
>
  <mat-menu #menu="matMenu">
    <ng-container *ngFor="let menuOption of menuOptions">
      <ng-container *ngIf="!menuOption.children?.length">
        <button
          mat-menu-item
          class="context-menu-button"
          [disabled]="menuOption.disabled"
          (click)="menuOption.action()"
        >
          <div class="menu-item">
            <span>{{ menuOption.label }}</span>
            <span>{{ menuOption.shortcut }}</span>
          </div>
        </button>
      </ng-container>

      <ng-container *ngIf="menuOption.children?.length">
        <button
          mat-menu-item
          class="context-menu-button"
          [disabled]="menuOption.disabled"
          [matMenuTriggerFor]="children"
        >
          <div class="menu-item">
            <span>{{ menuOption.label }}</span>
            <span>{{ menuOption.shortcut }}</span>
          </div>
        </button>
        <mat-menu #children="matMenu">
          <ng-container *ngFor="let child of menuOption.children">
            <button
              mat-menu-item
              class="context-menu-button"
              [disabled]="child.disabled"
              (click)="child.action()"
            >
              <div class="menu-item">
                <span>{{ child.label }}</span>
                <span>{{ child.shortcut }}</span>
              </div>
            </button>
          </ng-container>
        </mat-menu>
      </ng-container>
    </ng-container>
  </mat-menu>
</span>
